import React, { useEffect, useState } from "react";
import { ICreateProfile, IUpdateProfile } from "../../../../@types/profile";
import { updateProfile } from "../../../../backend-services";
import { EditProfile } from "./EditForm";
import { useUserStore } from "../../../../state";
import ErrorComponent from "../../../Error";
import { CloseIcon } from "../../../../assets/icons";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../../utils/toastUtils";
import { useCompanyStore } from "../../../../state/useCompanyStore";

interface CreateEditProfileProps {
  onCreateEditProfile?: (profile: ICreateProfile) => void;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  show: boolean;
  onClose?: () => void;
}

const CreateEditProfile = ({
  onCreateEditProfile,
  show,
  onClose,
}: CreateEditProfileProps) => {
  const { t } = useTranslation("settings");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [, setErrorMessage] = React.useState("");
  const { company: user, setCompany, fetchCompanyProfile } = useCompanyStore();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    businessName: "",
    phone: "",
    industry: "",
    address: "",
    state: "",
    city: "",
    code: "",
    businessSize: "",
    brandColor: "",
    isVerified: false,
  });
  const handleEditProfile = async (profile: IUpdateProfile) => {
    setIsLoading(true);
    try {
      const updatedFields: Partial<IUpdateProfile> = {};
      for (const key of Object.keys(profile)) {
        if (Object.prototype.hasOwnProperty.call(profile, key)) {
          if (
            //@ts-ignore
            formData[key as keyof IUpdateProfile] !==
            profile[key as keyof IUpdateProfile]
          ) {
            //@ts-ignore
            updatedFields[key as keyof IUpdateProfile] =
              profile[key as keyof IUpdateProfile];
          }
        }
      }
      const data = await updateProfile(updatedFields);
      setCompany(data);
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...data,
      }));
      fetchCompanyProfile();
      setIsLoading(false);
      setIsOpen(false);
      showToast("Profile Changes saved", "success");
      onCreateEditProfile && onCreateEditProfile(data);
      onClose && onClose();
    } catch (e) {
      setIsLoading(false);
      setErrorMessage("Unable to update profile.");
      return <ErrorComponent errorCode={500} />;
    }
  };

  useEffect(() => {
    if (user) {
      setFormData((prev) => ({
        ...prev,
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        businessName: user.businessName || "",
        phone: user.phone || "",
        industry: user.industry || "",
        address: user.address || "",
        state: user.state || "",
        city: user.city || "",
        code: user.code || "",
        businessSize: user.businessSize || "",
        brandColor: user.brandColor || "", // Check if this key exists
        isVerified: user.isVerified || false,
        logoBase64: user.logoBase64,
      }));
    }
  }, [user]);

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  useEffect(() => {
    setIsOpen(show); // Sync `isOpen` with `show` prop
  }, [show]);

  return (
    <>
      <div className="  flex mt-[-2em] w-full ">
        <div className="bg-white rounded-lg  w-full">
          <h2 className="text-xl font-medium border-b py-6 hidden md:block">
            My account
          </h2>
          <h2 className="text-xl font-medium border-b py-6 md:hidden">
            Edit account
          </h2>
          <div className="mt-[2em]">
            <EditProfile
              isLoading={isLoading}
              show={isOpen}
              onSubmit={handleEditProfile}
              data={formData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export { CreateEditProfile };
